import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dropdown" }
const _hoisted_2 = {
  ref: "chatDropdown",
  "data-bs-toggle": "dropdown",
  "data-bs-auto-close": "outside",
  class: /*#__PURE__*/_normalizeClass(
        `btn btn-icon d-none d-md-block drawer-state-button bg-hover-light mt-3 me-3 w-35px h-35px position-relative`
      )
}
const _hoisted_3 = {
  class: "dropdown-menu",
  "aria-labelledby": "chatDropdownMenu"
}
const _hoisted_4 = { class: "d-flex flex-column min-w-400px min-w-100-sm pb-7 px-7" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UnreadMessagesCounter = _resolveComponent("UnreadMessagesCounter")!
  const _component_SearchIcon = _resolveComponent("SearchIcon")!
  const _component_ChatHistory = _resolveComponent("ChatHistory")!
  const _component_ChatWindow = _resolveComponent("ChatWindow")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", _hoisted_2, [
      _createVNode(_component_UnreadMessagesCounter),
      _createVNode(_component_SearchIcon, {
        class: _normalizeClass(_ctx.isOpen ? 'svg-icon-primary' : 'svg-icon-gray-500')
      }, null, 8, ["class"])
    ], 512),
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/live-chat'))),
      class: _normalizeClass(
        `btn btn-icon d-block d-md-none drawer-state-button bg-hover-light mt-3 me-3 w-35px h-35px position-relative`
      )
    }, [
      _createVNode(_component_UnreadMessagesCounter),
      _createVNode(_component_SearchIcon, { class: "svg-icon-gray-500" })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_ctx.selectedChat == null)
          ? (_openBlock(), _createBlock(_component_ChatHistory, {
              key: 0,
              "is-drawer": true,
              class: "pt-4",
              ref: "drawerChatHistory",
              onChangeSelectedChat: _ctx.handleSelectChat
            }, null, 8, ["onChangeSelectedChat"]))
          : (_openBlock(), _createBlock(_component_ChatWindow, {
              key: 1,
              onCloseDrawerChat: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleSelectChat(null))),
              "is-drawer": true,
              data: _ctx.selectedChat
            }, null, 8, ["data"]))
      ])
    ])
  ]))
}